import React from 'react';
import { Link } from 'react-router-dom';
import SuperAdminDashboard from '../Dashboard/SuperAdminDashboard';
import PathfinderDashboard from './PathfinderDashboard';

// Build-time opt-in keeps the existing dashboard as the rollback path.
export const isPathfinderEnabled = () => process.env.REACT_APP_SUPER_ADMIN_PATHFINDER_ENABLED === 'true';

export default function PathfinderEntry() {
  if (!isPathfinderEnabled()) return <SuperAdminDashboard />;
  return <PathfinderDashboard management={<>
    <h2>Organization and system management</h2>
    <div className="pf-actions">
      <Link to="/superadmin/management">Organizations and create organization</Link>
      <Link to="/superadmin/visibility-metrics">Product activity</Link>
      <Link to="/superadmin/blueprints">Blueprint Templates</Link>
      <Link to="/admin/faqs">Wiki and FAQ Editor</Link>
    </div>
  </>} />;
}
